import { ExecutionSession, ConnectionStatus, ExecutionStatus } from "./executionState";
import { ExecutionEvent } from "./executionEvents";

export type ExecutionAction =
  | { type: "START_EXECUTION"; payload: { executionId: string } }
  | { type: "CONNECTION_CHANGED"; payload: ConnectionStatus }
  | { type: "RECEIVE_EVENT"; payload: { sequence: number; event: ExecutionEvent } }
  | { type: "RESET" };

export function executionReducer(state: ExecutionSession, action: ExecutionAction): ExecutionSession {
  switch (action.type) {
    case "START_EXECUTION":
      return {
        ...state,
        executionId: action.payload.executionId,
        executionStatus: "queued",
        connectionStatus: "connected",
        lastEventId: 0,
      };

    case "CONNECTION_CHANGED":
      return {
        ...state,
        connectionStatus: action.payload,
      };

    case "RECEIVE_EVENT": {
      const { sequence, event } = action.payload;

      // Idempotent event consumption: ignore duplicates
      if (sequence > 0 && sequence <= state.lastEventId) {
        return state;
      }

      const newState = { ...state, lastEventId: Math.max(state.lastEventId, sequence) };

      switch (event.type) {
        case "execution.queued":
          newState.executionStatus = "queued";
          break;
        case "message.delta":
        case "token":
        case "agent.step":
        case "agent_step":
        case "node.started":
        case "node.completed":
          // If we receive tokens/steps, we are actively running
          newState.executionStatus = "running";
          break;
        case "execution.completed":
          newState.executionStatus = "completed";
          break;
        case "execution.failed":
        case "error":
          newState.executionStatus = "failed";
          break;
        case "execution.cancelled":
          newState.executionStatus = "cancelled";
          break;
        case "heartbeat":
          // Just update lastEventId (if any) and keep connection alive
          break;
      }
      return newState;
    }

    case "RESET":
      return {
        executionId: null,
        executionStatus: null,
        connectionStatus: "disconnected",
        lastEventId: 0,
      };

    default:
      return state;
  }
}
